import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useClientAuth } from "../../contexts/ClientAuthContext";
import { upsertClientProfile } from "../../services/clientProfileService";
import "./client.css";

export default function ClientRegister() {
    const { isSupabaseReady, signUp } = useClientAuth();
    const navigate = useNavigate();

    const [fullName, setFullName] = useState("");
    const [company, setCompany] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError("");
        setSuccessMessage("");

        if (!isSupabaseReady) {
            setError("Supabase yapılandırması olmadan kayıt işlemine izin verilmiyor.");
            return;
        }

        if (password !== confirmPassword) {
            setError("Şifreler eşleşmiyor.");
            return;
        }

        try {
            setSubmitting(true);
            const result = await signUp({
                email,
                password,
                metadata: {
                    full_name: fullName,
                    company,
                    phone,
                },
            });

            const user = result?.user ?? result?.session?.user ?? null;
            if (user) {
                try {
                    await upsertClientProfile({
                        id: user.id,
                        fullName,
                        company,
                        phone,
                    });
                } catch (profileError) {
                    console.warn("Profil kaydedilirken hata oluştu", profileError);
                }
            }

            if (!result?.session) {
                setSuccessMessage(
                    "Kayıt başarılı! Lütfen e-posta kutunuzu kontrol edin ve doğrulama bağlantısını tıklayarak giriş yapın."
                );
                setSubmitting(false);
                return;
            }

            navigate("/client/dashboard", { replace: true });
        } catch (signUpError) {
            setError(signUpError.message ?? "Kayıt işlemi tamamlanamadı. Lütfen bilgilerinizi kontrol edin.");
            setSubmitting(false);
        }
    };

    if (!isSupabaseReady) {
        return (
            <div className="client-shell">
                <div className="client-card">
                    <div className="client-card__header">
                        <span className="client-card__badge">Modelerman</span>
                        <h1 className="client-card__title">Müşteri kaydı devre dışı</h1>
                        <p className="client-card__subtitle">
                            Supabase ortam değişkenleri tanımlanmadığı için kayıt ekranı etkinleştirilemiyor. Lütfen önce Supabase
                            projesini yapılandırın.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="client-shell">
            <div className="client-card">
                <div className="client-card__header">
                    <span className="client-card__badge">Modelerman</span>
                    <h1 className="client-card__title">Müşteri hesabı oluştur</h1>
                    <p className="client-card__subtitle">
                        Projelerinize ait dosyalar, revizyon notları ve takvim bilgileri bu panelde saklanır. Formu doldurduktan sonra
                        doğrulama e-postasını onaylayın.
                    </p>
                </div>

                <form className="client-form" onSubmit={handleSubmit}>
                    <label htmlFor="register-fullname">
                        Ad Soyad
                        <input
                            id="register-fullname"
                            type="text"
                            autoComplete="name"
                            value={fullName}
                            onChange={(event) => setFullName(event.target.value)}
                            placeholder="İsim Soyisim"
                            required
                        />
                    </label>

                    <label htmlFor="register-company">
                        Şirket / Marka (opsiyonel)
                        <input
                            id="register-company"
                            type="text"
                            value={company}
                            onChange={(event) => setCompany(event.target.value)}
                            placeholder="Örn. Modelerman Yapı"
                        />
                    </label>

                    <label htmlFor="register-phone">
                        Telefon (opsiyonel)
                        <input
                            id="register-phone"
                            type="tel"
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)}
                            placeholder="+90 5xx xxx xx xx"
                        />
                    </label>

                    <label htmlFor="register-email">
                        E-posta
                        <input
                            id="register-email"
                            type="email"
                            autoComplete="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="mail@ornek.com"
                            required
                        />
                    </label>

                    <label htmlFor="register-password">
                        Şifre
                        <input
                            id="register-password"
                            type="password"
                            autoComplete="new-password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            placeholder="En az 8 karakter"
                            minLength={8}
                            required
                        />
                    </label>

                    <label htmlFor="register-password-confirm">
                        Şifre (tekrar)
                        <input
                            id="register-password-confirm"
                            type="password"
                            autoComplete="new-password"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            placeholder="Şifrenizi tekrar yazın"
                            minLength={8}
                            required
                        />
                    </label>

                    {error && <p className="client-form__error">{error}</p>}
                    {successMessage && <p className="client-form__hint">{successMessage}</p>}

                    <button className="client-form__submit" type="submit" disabled={submitting}>
                        {submitting ? "Kaydediliyor..." : "Hesap oluştur"}
                    </button>
                </form>

                <p className="client-form__hint">
                    Zaten hesabınız var mı? <Link className="client-form__link" to="/client/login">Giriş yap</Link>
                </p>
            </div>
        </div>
    );
}
